module.exports = __webpack_public_path__ + "5b67363b43880dc083fe2d0b7e7dc4c1.MP3";